import About from '../components/About';
import Services from '../components/Services';
import Team from '../components/Team';

function Main() {
  return (
    <>
      <main>
        <Services />
        <About />
        <Team />
      </main>
    </>
  );
}
export default Main;
